module.exports = __webpack_public_path__ + "img/Suriname.97c4a29e.svg";